/**
 * 阻止事件冒泡的 React 事件处理工具函数
 * @param e React 合成事件对象
 */
export function stopPropagation(
  e: React.SyntheticEvent,
  options?: { stopImmediatePropagation?: boolean },
): void {
  e.stopPropagation()
  if (options?.stopImmediatePropagation) {
    e.nativeEvent.stopImmediatePropagation()
  }
}
/**
 * 阻止react合成事件合原生事件的冒泡
 * @param e
 */
export const stopAllPropagation = (e: React.SyntheticEvent) => {
  stopPropagation(e, { stopImmediatePropagation: true })
}
/**
 * 阻止事件冒泡的 React 事件处理工具函数
 * @param e React 合成事件对象
 */
export function stopPropagation(
  e: React.SyntheticEvent,
  options?: { stopImmediatePropagation?: boolean },
): void {
  e.stopPropagation()
  if (options?.stopImmediatePropagation) {
    e.nativeEvent.stopImmediatePropagation()
  }
}
/**
 * 阻止react合成事件合原生事件的冒泡
 * @param e
 */
export const stopAllPropagation = (e: React.SyntheticEvent) => {
  stopPropagation(e, { stopImmediatePropagation: true })
}
